<template>
  <div class="header" :class="{inside: showBack}">
    <div class="selects" v-if="showLanguage">
        <span class="cc" @click="toggleLanguage"><a href="javascript:" @click="navigateToAntherLanguage">EN</a></span>
        <ul v-show="languageVisible">
          <li class="" style="text-align: center; cursor: text;" @click="navigateToChinese">中文</li>
        </ul>
      </div>
    <div class="logo">
      <a class="inside" href="javascript: void(0)" v-if="showBack">
        <img class="icon-back" src="../../assets/images/nicon-search-back.png" alt="" @click="goBack">
        <img src="../../assets/images/nlogo.png" alt="" @click="goHome">
      </a>
      <a href="/" v-else>
        <img src="../../assets/images/nlogo.png" alt="">
      </a>
    </div>
    <div class="user">
      <span v-if="name" @click="logoutAction">
        Hi，{{ this.name }}
        <img src="../../assets/images/nicon-power.png" alt="">
      </span>
      <span @click="loginAction" v-else>
        <img src="../../assets/images/nicon-user.png" alt="">
      </span>
    </div>
  </div>
</template>

<script>
  import config from  '../../common/config';
  import axios from 'axios';
  export default {
    props: [
      'showBack',
      'callback',
      'showLanguage'
    ],
    data() {
      return {
        name: '',
        config,
        languageVisible: false
      }
    },
    mounted() {
      this.getUserInfo();
    },
    methods: {
      // 获取用户信息
      getUserInfo() {
        axios.get(config.MAPI + '/safety/account/get?queryType=1')
        .then(r => {
          if (r.data.code === 1) {
            this.name = r.data.obj.name;
            this.callback && this.callback(r.data.obj);
          }
        });
      },
      // 登录
      loginAction() {
        window.location.href = config.USERAPI + 'mobile/uc/build/login?returnUrl=' + encodeURIComponent(encodeURIComponent(window.location.href));
      },
      // 退出登录
      logoutAction() {
        axios.get(config.MAPI + '/security/logout')
        .then(r => {
          if(r.data.code === 1) {
            this.name = '';
            this.callback && this.callback(null);
          }
        });
      },
      // 返回上一页
      goBack() {
        window.history.back();
      },
      // 返回首页
      goHome() {
        window.location.href = '/';
      },
      toggleLanguage() {
        this.languageVisible = !this.languageVisible
      },
      navigateToChinese() {
        window.location.reload()
      },
       navigateToAntherLanguage(event) {
        event.stopPropagation()
        window.location.href = window.location.href.replace(/m(-stg)?\./, (match, p1) => {
          return p1 ? `m-stg-en.` : `m.en.`;
        })
      }
    }
  }
</script>

<style lang="less" scoped="scoped">
  .header {
    display: flex;
    align-items: center;
    clear: both;
    padding: 3.2rem 2.4rem 2.1rem;
    position: relative;
    &.inside {
      padding: 3.2rem 2.4rem 4.2rem 2.4rem;
    }
    .logo {
      flex: 1;
      img {
        display: block;
        width: 8rem;
      }
      .inside {
        display: flex;
        align-items: center;
        img {
          display: block;
          width: 6rem;
        }
        .icon-back {
          width: .8rem;
          margin-right: 2rem;
        }
      }
    }
    .user {
      margin-top: .1rem;
      a,
      span{
        display: flex;
        align-items: center;
        color: #909dd8;
        font-size: 1.4rem;
      }
      img {
        display: inline-block;
        width: 1.4rem;
        margin-left: 1rem;
      }
    }
  }

   .selects {
      width: 60px;
      border-radius: 5px;
      margin-top: 10px;
      margin-right: 2.4rem;
      position: absolute;
      top: 0;
      right: 0;
      background-position: right -52px;
      height: 20px;
      cursor: pointer;
      background: url(https://zt.ibuychem.com/cms/en/arr.png) 52px 8px no-repeat;
  }

  .selects:hover {
      background-position: 52px -31px;
  }

  .selects span {
      display: block;
      cursor: pointer;
      padding-left: 22px;
      background: url(https://zt.ibuychem.com/crossborder/images/img_14.png) no-repeat 0 center;
      background-size: 14px 14px;
      font-style: normal;
      border-radius: 5px;
      font-size: 12px;
      position: relative;
  }

  .selects span a {
      color: #fff;
  }

  .selects ul {
      overflow-y: auto;
      background: #fff;
      border: 1px solid #e1e1e1;
      border-top: 0;
      position: absolute;
      right: 0;
      width: 100%;
      top: 20px;
  }

  .selects ul li {
      cursor: pointer;
      height: 24px;
      line-height: 24px;
      color: #666;
      padding-left: 0 !important;
      display: block;
      float: none !important;
  }

  .selects ul li a {
      color: #666;
      display: block;
      text-align: center;
      margin-left: 0 !important;
      margin-right: 0 !important;
  }

  .selects ul li a img {
      display: inline-block;
      vertical-align: middle;
      width: 14px;
      margin-right: 4px;
      margin-top: -1px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue